<template>
  <div
    class="right-panel"
    @click="panelClicked">
    <div class="right-panel-body">
    <div class="history-actions">
      <div class="history-undo-group">
        <button
          v-tooltip="'Undo'"
          type="button"
          class="history-btn"
          aria-label="Undo"
          title="Undo"
          @click="undoChanges">
          <layer-icon name="undo" :size="16"/>
        </button>
        <button
          v-tooltip="'Redo Last Action'"
          id="redo"
          type="button"
          class="history-btn"
          aria-label="Redo Last Action"
          title="Redo Last Action"
          @click="redoChanges">
          <layer-icon name="redo" :size="16"/>
        </button>
      </div>
      <div class="history-reset">
        <button
          v-tooltip="'Reset Changes'"
          :disabled="isResetDisabled"
          type="button"
          class="history-btn history-btn--reset"
          aria-label="Reset Changes"
          title="Reset Changes"
          @click="resetUndoRedoArray">
          <layer-icon name="reset" :size="16"/>
          <span>Reset</span>
        </button>
      </div>
    </div>
    <layer-tag
      :content-list-receive="contentList"
      :product="product"
      :active-page="getActivePageIndex"
    />
    </div>
    <span class="version-info">v3.35 (4SEP26)</span>
  </div>
</template>
<script>


import Layer from '@/components/Layer/Layer';
import ColorPicker from '@/components/ColorPicker/ColorPicker';
import LayerIcon from '@/components/Layer/LayerIcon.vue';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:       'RightPanel',
  components: {
    'layer-tag': Layer,
    'color-tag': ColorPicker,
    LayerIcon,
  },
  props: {
    product: {
      type: Object,
    },
    contentList: {
      type:    Array,
      default: [],
    },
    activePage: {
      type:    Number,
      default: -1,
    },
  },
  data() {
    return { isResetDisabled: true };
  },
  computed: {
    getActivePageIndex() {
      return this.activePage;
    },
  },
  mounted() {
    EventBus.$on('setValueForUndoRedoReset', this.onSetValueForUndoRedoReset);
  },
  destroyed() {
    EventBus.$off('setValueForUndoRedoReset', this.onSetValueForUndoRedoReset);
  },
  methods: {
    panelClicked() {
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CLOSE_PRODUCT_SIZE_DROPDOWN);
    },
    onSetValueForUndoRedoReset(value) {
      this.isResetDisabled = value;
    },
    undoChanges() {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'undo');
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_DURATION_UPDATED, 'undo');
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.MULTI_OBJETCS_CLEAR);
    },
    redoChanges() {
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_UPDATED, 'redo');
      // EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.PRODUCT_DURATION_UPDATED, 'redo');
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.MULTI_OBJETCS_CLEAR);
    },
    resetUndoRedoArray() {
      EventBus.$emit('pauseVideoOnOutsideClick');
      EventBus.$emit(ApplicationEventTypes.UndoRedoEvents.RESET_PAGE_UNDO_REDO);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.MULTI_OBJETCS_CLEAR);
    },
    showTooltip(e) {
      const Id = e.currentTarget.id;
      EventBus.$emit('checkToolTip', Id);
    },
    hideTooltip() {
      EventBus.$emit('triggerHide');
    },
  },
};

</script>
<style lang="scss">
.right-panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 256px;
  height: calc(100vh - 68px);
  max-height: calc(100vh - 68px);
  overflow: hidden;
  position: relative;
  background: #FBFBFC;
  border-left: 1px solid #E7E9ED;
  padding: 0;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
  -webkit-font-smoothing: antialiased;
}

.panel-kicker {
  font-family: "Geist";
  font-size: 11px;
  font-weight: 600;
  color: #5E6573;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.right-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.version-info {
  flex: 0 0 auto;
  display: block;
  padding: 8px 10px;
  text-align: right;
  background: #FBFBFC;
  pointer-events: none;
  font-size: 10.5px;
  color: #5E6573;
}


.history-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 0 12px;
}

.history-undo-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: #F3F4F6;
  border-radius: 9px;
}

.history-reset {
  display: flex;
  margin-left: auto;
  padding: 2px;
  border-radius: 9px;
  background: #FFFFFF;
  box-shadow: inset 0 0 0 1px #D5D9E0;
}

.history-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #3D4350;
  cursor: pointer;
  font-family: inherit;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.7);
  }

  &:focus {
    outline: none;
    border: 0;
  }

  &:focus-visible {
    outline: 2px solid #1570EF;
    outline-offset: 1px;
  }

  &:disabled {
    color: #9AA0AA;
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.history-btn--reset {
  width: auto;
  gap: 6px;
  padding: 0 10px;

  span {
    font-size: 12.5px;
    font-weight: 500;
  }

  &:hover:not(:disabled) {
    background: #F3F4F6;
  }
}
</style>
